export const modifiedTokens = {
    tokens: {},
    contexts: {
        "top-navigation": {
            tokens: {}
        },
        header: {
            tokens: {}
        },
        flashbar: {
            tokens: {}
        },
        alert: {
            tokens: {
                colorTextStatusWarning: {
                    light: "FFFF00",
                    dark: "FFFF00"
                }
            }
        }
    }
}
